import { request } from "../libs";

function fetchMeta(domain) {
	return request(
		`/server/${domain}/meta`,
		{ method: "GET" }
	)
		.then(res => res.json());
}

export default fetchMeta;



// WEBPACK FOOTER //
// ./src/api/fetch-meta.js